import { Divider } from '@delmonicos/shared-design-system-react/src/components/divider/divider';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { useGetTokensPaginatedFormValidation } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/tokens/models/inputs/get-tokens-paginated.form-validation';
import { GetTokensPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/tokens/models/inputs/get-tokens-paginated.model';
import { Controller, useFormContext } from 'react-hook-form';

import { TokenIsValidFilterController } from '../../token-is-valid-filter/token-is-valid-filter.controller';
import { TokenTypeFilterController } from '../../token-type-filter/token-type-filter.controller';

// react-hook-form's Controller falls back to its mount-time default whenever
// the live field value is `undefined`, so the "valid" filter control uses
// `null` for "All" instead. The SDK model still declares this field as
// `boolean | undefined` — this is the single, intentional seam where a live
// `null` is widened to that type; token-list-filter.controller.tsx
// normalizes it back to `undefined` (`?? undefined`) before it reaches the
// actual query parameters.
const toClearableFieldValue = (value: boolean | null): boolean | undefined =>
  value as unknown as boolean | undefined;

const TokenListFilterFormStep1ValidFragment = (): React.JSX.Element => {
  // CONTEXT /////////////////////////////////////////////////////////////////

  // const { t } = useTranslation();
  const { control } = useFormContext<GetTokensPaginatedModel>();
  const { valid } = useGetTokensPaginatedFormValidation();

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <>
      <Controller
        name="valid"
        control={control}
        rules={valid}
        render={({ field /* , fieldState: { error } */ }) => {
          return (
            <TokenIsValidFilterController
              selectedItem={field.value}
              onChange={(value) => field.onChange(toClearableFieldValue(value))}
            />
          );
        }}
      />
      <Divider />
    </>
  );
};

const TokenListFilterFormStep1TypeFragment = (): React.JSX.Element => {
  // CONTEXT /////////////////////////////////////////////////////////////////

  // const { t } = useTranslation();
  const { control } = useFormContext<GetTokensPaginatedModel>();
  const { type } = useGetTokensPaginatedFormValidation();

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Controller
      name="type"
      control={control}
      rules={type}
      render={({ field /* , fieldState: { error } */ }) => {
        return (
          <TokenTypeFilterController
            selectedItem={field.value}
            onChange={(value) => field.onChange(value)}
          />
        );
      }}
    />
  );
};

export const TokenListFilterFormStep1Controller = (): React.JSX.Element => {
  // RENDER //////////////////////////////////////////////////////////////////

  return (
    <Stack
      direction="row"
      justifyContent="stretch"
      alignItems="stretch"
      flex={1}
      gap={GapEnum.M}>
      <Stack direction="column" flex={1} alignItems="stretch" gap={GapEnum.M}>
        <TokenListFilterFormStep1ValidFragment />
        <TokenListFilterFormStep1TypeFragment />
      </Stack>
    </Stack>
  );
};
